var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#233c52",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.855 6.163 13.429 11.673"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M5.881 18.022 19.258 5.978"
  }))));
};
export { SvgClose as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICA8ZyBpZD0ibWVudSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTY4NCAtMzgwKSI+CiAgICA8cGF0aCBpZD0iVmVjdG9yIiBkPSJNMCwwSDE3Ljc5MyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNjg5Ljg1NSAzODYuMTYzKSByb3RhdGUoNDEpIiBmaWxsPSJub25lIiBzdHJva2U9IiMyMzNjNTIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KICAgIDxwYXRoIGlkPSJWZWN0b3ItMiIgZGF0YS1uYW1lPSJWZWN0b3IiIGQ9Ik0wLDBIMTgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDY4OS44ODEgMzk4LjAyMikgcm90YXRlKC00MikiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzIzM2M1MiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2Utd2lkdGg9IjEuNSIvPgogICAgPHBhdGggaWQ9IlZlY3Rvci0zIiBkYXRhLW5hbWU9IlZlY3RvciIgZD0iTTAsMEgyNFYyNEgwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNjg0IDM4MCkiIGZpbGw9Im5vbmUiIG9wYWNpdHk9IjAiLz4KICA8L2c+Cjwvc3ZnPgo=";